module.exports = __webpack_public_path__ + "img/rivera.566f5696.jpg";